import request from '@/utils/request'

/**
 * 上报相似音乐数据
 * 2026-07-15 10:00:00
 * @author SnowRock
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function fetchSmlAdd(params) {
  return request.post('/fontend/similar/sml-add', params, {})
}

/**
 * 轮训相似音乐解析数据
 * 2026-07-15 10:00:00
 * @author SnowRock
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function fetchSmlGet(params) {
  return request.post('/fontend/similar/sml-get', params, {})
}

/**
 * 用户查询日志记录
 * 2026-07-15 10:00:00
 * @author SnowRock
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function fetchSmlList(params) {
  return request.post('/fontend/similar/sml-list', params, {})
}

/**
 * 用户查询日志记录
 * 2026-07-15 10:00:00
 * @author SnowRock
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function fetchSmlMatch(params) {
  return request.post('/fontend/similar/sml-match', params, {})
}